module.exports = __webpack_public_path__ + "img/light_logo.9254fd58.png";